export default __webpack_public_path__ + "static/media/accepted_payments.a9f85079.svg";